import React, { useCallback } from 'react';
import { VortexActions, VortexCanvas, VortexContainer } from '@rendering/vortex-react';
import { FusionVortexAdapterProvider } from './FusionVortexAdapterProvider';
import { VortexError } from '../../errors/VortexError';
import { useVortexIntializationOptions } from '../../hooks/useVortexInitializationOptions';
export function FusionVortexPreview({ children, cimDoc, view, user, renderOptions, onError = console.error, onPaint, onFusionPaint, fusionOptions, }) {
    const Canvas = useCallback((props) => React.createElement(VortexCanvas, Object.assign({ style: { width: '100%' } }, props)), []);
    const onInnerError = useCallback((error) => {
        // Use VortexError to identify the error coming from Vortex
        onError === null || onError === void 0 ? void 0 : onError(new VortexError(error));
    }, [onError]);
    const onAfterUpdate = useCallback((error) => {
        if (!error) {
            onPaint === null || onPaint === void 0 ? void 0 : onPaint();
        }
    }, [onPaint]);
    const initializationOptions = useVortexIntializationOptions({ view });
    return (React.createElement(FusionVortexAdapterProvider, { cimDoc: cimDoc, onFusionPaint: onFusionPaint, fusionOptions: fusionOptions, referrer: user.referer }, ({ fusionVortexAdapter }) => (React.createElement(VortexContainer, { productConfig: view.vortex.model.content || view.vortex.model.url, vortexDocumentAdapter: fusionVortexAdapter, user: user, cameraOptions: view.vortex.stage.content.cameraSettings, environmentOptions: view.vortex.stage.content.environmentSettings, onError: onInnerError, fallback: null, onAfterUpdate: onAfterUpdate, initializationOptions: initializationOptions }, (vortexState) => {
        if (!children) {
            return React.createElement(Canvas, null);
        }
        return children({
            Canvas,
            renderActions: (render) => {
                var _a, _b;
                return (React.createElement(VortexActions, { cameraViews: (_a = renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.cameraViews) !== null && _a !== void 0 ? _a : false, animations: (_b = renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.animations) !== null && _b !== void 0 ? _b : false }, (actionParams) => render(actionParams)));
            },
            status: {
                loading: vortexState.loadingModel || vortexState.updatingCanvas,
                error: vortexState.error,
            },
            vortexContext: vortexState,
        });
    }))));
}
//# sourceMappingURL=FusionVortexPreview.js.map